import * as React from "react";

import { UnifiedDriveWorkspace } from "@/views/drive/workspace/UnifiedDriveWorkspace";

export const SharedView: React.FC = () => <UnifiedDriveWorkspace initialScope="shared" />;
